// src/finance/components/InfoTip.tsx
// Petit « i » d'information (spec infobulles 2026-08-20). Bouton SVG SANS texte
// DOM : plusieurs tests font des égalités exactes sur le textContent des lignes,
// l'icône ne doit rien y ajouter. Bulle au survol et au clic (tactile), fermée
// au mouse leave / blur / Échap.
import { useState } from 'react'

export function InfoTip({ label, text }: { label: string; text: string }) {
  const [open, setOpen] = useState(false)
  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label={`À propos : ${label}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setOpen(false)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') setOpen(false)
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '15px',
          height: '15px',
          padding: 0,
          background: 'transparent',
          border: 'none',
          color: 'var(--dim)',
          cursor: 'help',
        }}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M12 16v-5M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 6px)',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'max-content',
            maxWidth: '280px',
            background: 'var(--elevated)',
            border: '1px solid var(--line-strong)',
            borderRadius: '8px',
            padding: '0.5rem 0.625rem',
            fontSize: '0.75rem',
            fontFamily: 'inherit',
            fontWeight: 400,
            lineHeight: 1.5,
            color: 'var(--fg)',
            textAlign: 'left',
            whiteSpace: 'normal',
            zIndex: 10,
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.35)',
          }}
        >
          {text}
        </span>
      )}
    </span>
  )
}
